package one.healthium.insights.ui.utils

import androidx.compose.material3.LocalTextStyle
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.sp
import one.healthium.insights.domain.models.TextStyleModel
import one.healthium.ui.common.utils.toFontStyle
import one.healthium.ui.common.utils.toFontWeight

@Composable
fun TextStyleModel?.toTextStyle(fallback: TextStyle = LocalTextStyle.current): TextStyle {
    return fallback.copy(
        color = this?.color?.resolve() ?: fallback.color,
        fontWeight = this?.fontWeight.toFontWeight() ?: fallback.fontWeight,
        fontSize = this?.fontSize?.sp ?: fallback.fontSize,
        fontStyle = this?.fontStyle?.toFontStyle() ?: fallback.fontStyle,
        textAlign = when (this?.alignment) {
            "left" -> TextAlign.Start
            "center" -> TextAlign.Center
            "right" -> TextAlign.End
            else -> fallback.textAlign
        }
    )
}